import {
  createFrontendPlugin,
  PageBlueprint,
  PluginHeaderActionBlueprint,
} from '@backstage/frontend-plugin-api';
import { agentsRootRouteRef } from '../../routes';
import { RiRobot2Line } from '@remixicon/react';

const agentHeaderActions = PluginHeaderActionBlueprint.make({
  params: defineParams =>
    defineParams({
      loader: () => import('./header-actions').then(m => <m.HeaderActions />),
    }),
});

const agentsLandingPage = PageBlueprint.make({
  params: {
    title: 'AI Agents Registry',
    path: '/agents',
    icon: <RiRobot2Line />,
    routeRef: agentsRootRouteRef,
    loader: () =>
      import('./agents-landing-page').then(m => <m.AgentsLandingPage />),
  },
});

export const agentsLandingPagePlugin = createFrontendPlugin({
  pluginId: 'agents-landing-page',
  extensions: [agentsLandingPage, agentHeaderActions],
});
